import React from 'react'
import PropTypes from 'prop-types'
import buildPosition from 'letter/components/header/util/buildPosition'

const HeaderItemImage = ({ data }) => {
  const {
    type,
    x,
    y,
    sortId,
    metaData: {
      color,
      width,
      height,
    },
  } = data

  const position = buildPosition({ x, y, width, height, sortId, type })
  const finalStyles = Object.assign({}, position, { 'background-color': color })

  return (
    <div style={finalStyles} />
  )
}

HeaderItemImage.propTypes = {
  data: PropTypes.object,
}

export default HeaderItemImage
